/* eslint-disable @typescript-eslint/no-unused-vars */
import { axiosInstance as axios } from 'helpers/axiosInstance';
import logger from 'utilities/logger';

//CMS is not exposed to the website, therefore we fetch the news via a Next.JS API
export const getNewsLetterFormDataFromApi = async (org: string): Promise<Models.NewsLetterSignUpFormResponse> => {
	return axios({
		url: `/engagement-api/v1/apsis/signup/GetSignupForm?organisationShortName=${org}`,
		method: 'GET',
	})
		.then((res) => {
			return res.data as Models.NewsLetterSignUpFormResponse;
		})
		.catch((error) => {
			const message = error?.response?.data?.message ?? error;
			logger.error(`NewsletterForm retrieval failed: ${message}`);
			return { resultFromDefinitionResponse: { success: false, errorMessage: error.message } };
		});
};
